<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Acknowledgements</p>
<p class="noindent">I am indebted to a number of people without whom these stories would never have been possible. It is impossible to mention each one here.</p>
<p class="noindent">Bandana, my wife, is behind every little success that I have as an author. She virtually brought me up as a writer.</p>
<p class="noindent">Dhruv, my etymologist son, played no little role in listening patiently and intelligently to a number of these stories as they progressed.</p>
<p class="noindent">I am indebted to Mohammad Saleem for translating one of these stories into Urdu. I am also grateful to him for always being so willing to help.</p>
<p class="noindent">The students of the Amaranatha Jha Hostel of the University of Allahabad deserve special thanks as it was for them that I wrote plays and discovered, in the process, that I could scribble a few lines of fiction.</p>
<p class="noindent">But the one whom I cannot leave out is Caleb Mason of Publerati. It was he who accepted these stories for publication and gave me a kind of reassurance in myself. His comments have meant the world to me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?4d22bb2d